/**
 * Voorwaarden en privacyverklaring: tekst uit `src/lib/teksten.ts`, die met
 * de code meegaat en dus op test en productie hetzelfde is.
 */

import { useTitel } from '../componenten/basis';
import { Pagina } from '../componenten/Schil';
import { TEKSTEN } from '../lib/teksten';

export function Tekstpagina({ sleutel, titel }: { sleutel: 'voorwaarden' | 'privacy'; titel: string }) {
  useTitel(titel);
  const tekst = TEKSTEN[sleutel];
  return (
    <Pagina smal>
      <article className="verschijn py-12 sm:py-16">
        <h1 className="text-4xl">{titel}</h1>
        <div className="alineas mt-6 text-inkt-zacht">
          {tekst.split(/\n\s*\n/).map((alinea, i) => (
            <p key={i}>{alinea}</p>
          ))}
        </div>
      </article>
    </Pagina>
  );
}
